import { useNavigate } from 'react-router-dom';
import { ShieldAlert, MessageCircle, LogOut, CreditCard } from 'lucide-react';
import { useAuthContext } from '../contexts/AuthContext';

export default function BillingBlockedPage() {
    const navigate = useNavigate();
    const { logout, user } = useAuthContext();

    return (
        <div className="min-h-screen bg-base-200 flex items-center justify-center px-4">
            <div className="w-full max-w-xl rounded-2xl border border-base-300 bg-base-100 shadow-2xl p-8 space-y-6">
                <div className="flex items-center gap-3 text-warning">
                    <ShieldAlert size={28} />
                    <h1 className="text-2xl font-bold text-base-content">Acesso temporariamente bloqueado</h1>
                </div>

                <p className="text-base-content/80">
                    O periodo de teste de <strong>14 dias</strong> foi encerrado. Para continuar usando o SalonFlow,
                    regularize o plano do estabelecimento.
                </p>

                <div className="rounded-xl border border-warning/30 bg-warning/10 p-4 text-sm text-base-content/80">
                    Assim que o pagamento for confirmado pelo Asaas, o acesso interno volta automaticamente.
                </div>

                <div className="flex flex-col sm:flex-row gap-3">
                    {user?.uid ? (
                        <button type="button" className="btn btn-primary flex-1" onClick={() => navigate('/meu-plano')}>
                            <CreditCard size={18} />
                            Regularizar meu plano
                        </button>
                    ) : (
                        <a
                            href="https://wa.me/5547997747307"
                            target="_blank"
                            rel="noreferrer"
                            className="btn btn-primary flex-1"
                        >
                            <MessageCircle size={18} />
                            Falar no WhatsApp
                        </a>
                    )}

                    <button onClick={logout} className="btn btn-outline flex-1">
                        <LogOut size={18} />
                        Sair da conta
                    </button>
                </div>
            </div>
        </div>
    );
}
